import { render, staticRenderFns } from "./ConfigureCompanyTemplatePreview.vue?vue&type=template&id=45f2149e&scoped=true"
import script from "./ConfigureCompanyTemplatePreview.vue?vue&type=script&lang=js"
export * from "./ConfigureCompanyTemplatePreview.vue?vue&type=script&lang=js"
import style0 from "./ConfigureCompanyTemplatePreview.vue?vue&type=style&index=0&id=45f2149e&prod&lang=scss&scoped=true"
import style1 from "./ConfigureCompanyTemplatePreview.vue?vue&type=style&index=1&id=45f2149e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f2149e",
  null
  
)

export default component.exports